import { render, staticRenderFns } from "./EditDialogReglements.vue?vue&type=template&id=3d470000&"
import script from "./EditDialogReglements.vue?vue&type=script&lang=ts&"
export * from "./EditDialogReglements.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports